import { render } from "./GraficoLinha.vue?vue&type=template&id=2633e64c&scoped=true"
import script from "./GraficoLinha.vue?vue&type=script&lang=js"
export * from "./GraficoLinha.vue?vue&type=script&lang=js"

import "./GraficoLinha.vue?vue&type=style&index=0&id=2633e64c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2633e64c"]])

export default __exports__